import { Component, EventEmitter, Output } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CoreService } from 'src/app/services/core.service';
import { CommonService } from 'src/app/services/common.service';
import { AppSettings } from 'src/app/config';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [MaterialModule, TablerIconsModule],
  template: `
    @if (options.theme === 'light') {
      <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="toggleTheme('dark')">
        <i-tabler class="d-flex icon-22" [name]="'moon'"></i-tabler>
      </button>
    } @else {
      <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="toggleTheme('light')">
        <i-tabler class="d-flex icon-22" [name]="'sun'"></i-tabler>
      </button>
    }
  `
})
export class ThemeToggleComponent {
  @Output() optionsChange = new EventEmitter<AppSettings>();
  htmlElement!: HTMLHtmlElement;
  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    private commonService: CommonService
  ) {
    this.htmlElement = document.querySelector('html')!;
    this.toggleDarkTheme();
    this.toggleColorsTheme();
  }

  toggleTheme(theme: string) {
    this.options.theme = theme;
    this.commonService.toggleTheme.next(theme);
    this.toggleDarkTheme();
    this.toggleColorsTheme();
    this.optionsChange.emit(this.options);
  }

  toggleDarkTheme() {
    if (this.options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme() {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(this.options.activeTheme);
  }
}
